import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { getCurrentWizardStep, getCurrentWizardStepIndex, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { RiskProfilesService } from 'RiskProfilesApp/services/risk-profiles.service';
import { resetSecondarySecurity, setSecondarySecurity, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/report-securities/report-securities.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import * as i0 from "@angular/core";
import * as i1 from "RiskProfilesApp/services/risk-profiles.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = () => ({ button: "btn btn-secondary btn-block" });
function SelectRiskProfileModelPortfolioModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "div", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ycn-single-select-dropdown", 14, 0);
    i0.ɵɵlistener("changeHandler", function SelectRiskProfileModelPortfolioModalComponent_div_6_Template_ycn_single_select_dropdown_changeHandler_4_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectedModelPortfolio = $event); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.riskProfile.name, " Profile Portfolios");
    i0.ɵɵadvance();
    i0.ɵɵproperty("appendToBody", true)("placeholderText", "Select")("customCssClasses", i0.ɵɵpureFunction0(5, _c0))("config", ctx_r1.modelPortfolioDropdownConfig);
} }
function SelectRiskProfileModelPortfolioModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function SelectRiskProfileModelPortfolioModalComponent_div_11_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.back()); });
    i0.ɵɵtext(1, "Back");
    i0.ɵɵelementEnd();
} }
/**
 * Select Risk Profile Model Portfolio Modal Component
 *
 * Modal with a dropdown of model portfolios from the selected risk profile.
 *
 * Output Properties:
 *  broadcastWizardStepEvent: Emits when the wizard should move to the previous step or next step.
 */
export class SelectRiskProfileModelPortfolioModalComponent {
    constructor(riskProfileService, store) {
        this.riskProfileService = riskProfileService;
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.open = false;
        this.currentWizardStepIndex = 0;
        this.currentWizardStep = null;
        this.isSelectRiskProfileStep = false;
        this.mapStateToComponent = (state) => {
            if (state.riskProfile && (!this.riskProfile || this.riskProfile.id !== state.riskProfile.id)) {
                this.riskProfile = state.riskProfile;
                this.riskProfileService.getRiskProfile(this.riskProfile.id).subscribe((riskProfile) => {
                    this.modelPortfolioDropdownConfig = {
                        list: riskProfile.model_portfolios.map((modelPortfolio) => {
                            return {
                                type: 'option',
                                label: modelPortfolio.name,
                                value: {
                                    securityId: modelPortfolio.security_object.security_id,
                                    securityName: modelPortfolio.security_object.security_name,
                                    displaySecurityID: modelPortfolio.security_object.display_security_id,
                                    securityType: modelPortfolio.security_object.security_type,
                                },
                            };
                        }),
                    };
                });
            }
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.currentWizardStep = getCurrentWizardStep(state);
            this.isSelectRiskProfileStep =
                this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_SELECT_RISK_PROFILE_MODAL;
            if (this.isSelectRiskProfileStep) {
                this.selectedModelPortfolio = null;
            }
            if (!this.open &&
                this.currentWizardStep?.eventName ===
                    CustomPDFReportModalEventName.SHOW_SELECT_RISK_PROFILE_MODEL_PORTFOLIO_MODAL) {
                this.openModal();
            }
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        this.open = true;
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
    }
    closeModal() {
        this.open = false;
    }
    back() {
        this.store.dispatch(decrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
        this.store.dispatch(resetSecondarySecurity());
        this.closeModal();
    }
    forward() {
        this.store.dispatch(setSecondarySecurity(this.selectedModelPortfolio));
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
        this.closeModal();
    }
}
SelectRiskProfileModelPortfolioModalComponent.ɵfac = function SelectRiskProfileModelPortfolioModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectRiskProfileModelPortfolioModalComponent)(i0.ɵɵdirectiveInject(i1.RiskProfilesService), i0.ɵɵdirectiveInject(i2.Store)); };
SelectRiskProfileModelPortfolioModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectRiskProfileModelPortfolioModalComponent, selectors: [["ycn-select-risk-profile-model-portfolio-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 13, vars: 6, consts: [["modelPortfolioDropdown", ""], [3, "closeModalHandler", "modalBaseClass", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "mb-3"], ["class", "row", 4, "ngIf"], [1, "modal-footer"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], ["class", "btn btn-secondary", 3, "click", 4, "ngIf"], [1, "btn", "btn-primary", 3, "click", "innerText"], [1, "row"], [1, "col-6"], [1, "form-label", "form-label-thin", "pb-1"], [1, "dropdown", 3, "changeHandler", "appendToBody", "placeholderText", "customCssClasses", "config"], [1, "btn", "btn-secondary", 3, "click"]], template: function SelectRiskProfileModelPortfolioModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function SelectRiskProfileModelPortfolioModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function SelectRiskProfileModelPortfolioModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "p");
        i0.ɵɵtext(5, "Select a portfolio that aligns with the Risk Profile from the dropdown list or click Next to select another portfolio.");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, SelectRiskProfileModelPortfolioModalComponent_div_6_Template, 6, 6, "div", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "div", 8);
        i0.ɵɵlistener("click", function SelectRiskProfileModelPortfolioModalComponent_Template_div_click_9_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵtext(10, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, SelectRiskProfileModelPortfolioModalComponent_div_11_Template, 2, 0, "div", 9);
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵlistener("click", function SelectRiskProfileModelPortfolioModalComponent_Template_div_click_12_listener() { return ctx.forward(); });
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.open);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Model Portfolio");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.riskProfile && !ctx.isSelectRiskProfileStep);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.currentWizardStepIndex);
        i0.ɵɵadvance();
        i0.ɵɵproperty("innerText", "Next");
    } }, dependencies: [i3.NgIf, i4.ModalBaseComponent, i5.SimpleModalHeaderComponent, i6.SingleSelectDropdownComponent], encapsulation: 2 });
